import { useState } from 'react';
import c from 'classnames';
import isEmpty from 'validator/lib/isEmpty';

import { useTranslation } from '@lyearn/i18n';
import { InputBase, Typography } from '@lyearn/ui';
import stopPropagation from '@/consts/stopPropogation';

import useCategoryActions from '../../../hooks/useCategoryActions';
import { CategoryType } from '../../../types';

const CategoryName = ({
  className,
  isEditing,
  category,
  actions: { onNameChange },
}: {
  className?: string;
  isEditing?: boolean;
  category: CategoryType;
  actions: ReturnType<typeof useCategoryActions>['actions'];
}) => {
  const { t } = useTranslation();
  const [value, setValue] = useState<string>(category.name);

  return isEditing ? (
    <InputBase
      autoFocus
      fullWidth
      className={c('body-short-01 h-24', className)}
      placeholder={t('Discover:Category.Admin.CategoryNamePlaceholder')}
      size="small"
      value={value}
      onBlur={(e) => onNameChange(category.id, e.currentTarget.value)}
      onChange={(e) => setValue(e.currentTarget.value)}
      onClick={stopPropagation}
    />
  ) : (
    <Typography className={className} numberOfLines={2} variant="body-short-01">
      {isEmpty(category.name.trim())
        ? t('Discover:Category.Admin.UntitledCategory')
        : category.name}
    </Typography>
  );
};

export default CategoryName;
